import { render, staticRenderFns } from "./RecentlyCatalogs.vue?vue&type=template&id=15fa5e5c&"
import script from "./RecentlyCatalogs.vue?vue&type=script&lang=js&"
export * from "./RecentlyCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports